import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Hidden from '@mui/material/Hidden'
import { lighten } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import Typography from '@mui/material/Typography'
import { Link2Video } from 'lib/links'
import { getImageURL } from 'lib/utils'
import LazyLoad from 'react-lazyload'

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(3),
    cursor: 'pointer'
  },
  actionArea: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    height: '120px'
  },
  image: {
    width: '160px',
    minWidth: '160px',
    height: '120px',
    background: 'linear-gradient(' + theme.palette.background.default + ', ' + lighten(theme.palette.background.default, 0.5) + ')'
  },
  durationWrapper: {
    position: 'absolute',
    top: '103px',
    left: 0,
    width: '160px',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  duration: {
    backgroundColor: 'rgba(0,0,0,.7)',
    color: 'white',
    textAlign: 'right',
    fontWeight: 'bold',
    fontSize: '11px',
    padding: '1px 3px'
  },
  title: {
    height: '25px',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      height: '70px'
    }
  },
  subtitle: {
    height: '20px',
    overflow: 'hidden'
  },
  description: {
    height: '40px',
    overflow: 'hidden'
  },
  position: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    position: 'absolute',
    top: 0,
    padding: '5px',
    fontWeight: 'bold',
    display: 'inline-block',
    textAlign: 'center'
  }
}))

export default function SearchResult ({ result, lazy = false, position }) {
  const classes = useStyles()

  function SearchResultImage ({ result, classes }) {
    return (
      <CardMedia
        component='img'
        image={getImageURL(result._source.image, result._source.stations[0].slug)}
        title={result._source.fullTitle}
        alt={result._source.fullTitle}
        className={classes.image}
        width={160}
        heigh={120}
      />
    )
  }

  function LazySearchResultImage ({ result, classes, lazy }) {
    if (lazy) {
      return <LazyLoad offset={100} once><SearchResultImage result={result} classes={classes} /></LazyLoad>
    } else {
      return <SearchResultImage result={result} classes={classes} />
    }
  }

  const description = (result) => {
    if (result.highlight && result.highlight.description) {
      return result.highlight.description
    } else {
      return result._source.description
    }
  }

  return (
    (
      <Card className={classes.card} data-test='search-result'>
        <Link2Video slug={result._source.slug}>
          <CardActionArea className={classes.actionArea}>
            {position &&
              <Typography gutterBottom variant='body2' className={classes.position}>{position}</Typography>}
            <LazySearchResultImage result={result} lazy={lazy} classes={classes} />
            <span className={classes.durationWrapper}>
              <span className={classes.duration}>{result._source.duration} min</span>
            </span>

            <CardContent className={classes.content}>
              <Typography
                variant='h3'
                component='h3'
                className={classes.title}
                dangerouslySetInnerHTML={{ __html: result._source.fullTitle }}
              />
              <Typography variant='body2' color='textSecondary' gutterBottom className={classes.subtitle}>
                {result._source.date}
            &nbsp;|&nbsp;{result._source.stations[0].name}
              </Typography>
              <Hidden smDown>
                <Typography
                  variant='body2'
                  className={classes.description}
                  dangerouslySetInnerHTML={{ __html: description(result) }}
                />
              </Hidden>
            </CardContent>
          </CardActionArea>
        </Link2Video>
      </Card>
    )
  )
}
